import './LegalPage.css';

export default function Impressum() {
  return (
    <article className="legal">
      <span className="eyebrow">Rechtliches</span>
      <h1>Impressum</h1>
      <p className="legal__meta">
        Angaben gemäß § 5 ECG (Österreich), § 5 TMG (Deutschland) sowie § 25
        MedienG (Österreich). Informationspflichten nach § 18 Abs. 2 MStV
        (Deutschland).
      </p>

      <h2>Medieninhaber, Herausgeber &amp; Anbieter</h2>
      <p>
        BONUSCLUB LLC
        <br />
        7901 4th St N, Ste 300
        <br />
        St. Petersburg, FL 33702
        <br />
        United States of America
      </p>
      <p>
        Rechtsform: Limited Liability Company (LLC) nach Recht des
        US-Bundesstaates Florida.
        <br />
        Registriert beim Florida Department of State, Division of Corporations
        (<a
          href="https://search.sunbiz.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          sunbiz.org
        </a>
        ).
      </p>

      <h2>Kontakt</h2>
      <p>
        Die Kontaktaufnahme erfolgt ausschließlich über das{' '}
        <a href="/#kontakt">Kontaktformular</a> auf dieser Website. Aus Gründen
        der Diskretion und zur Vermeidung von Spam veröffentlichen wir keine
        direkten Telefon- oder E-Mail-Adressen.
      </p>
      <p className="legal__hint">
        Anfragen werden in der Regel innerhalb von 48 Stunden (Werktags)
        beantwortet.
      </p>

      <h2>Vertretungsberechtigter / Managing Partner</h2>
      <p>Julian Propst</p>

      <h2>
        Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV / § 25 MedienG
      </h2>
      <p>
        Julian Propst
        <br />
        c/o BONUSCLUB LLC
        <br />
        7901 4th St N, Ste 300
        <br />
        St. Petersburg, FL 33702, USA
      </p>

      <h2>Unternehmensgegenstand</h2>
      <p>
        Pre Market Scouting – Recherche, Aufbereitung und Vermittlung von
        Informationen zu Off-Market-Immobilien im Auftrag von Käufer:innen.
        BONUSCLUB LLC tritt dabei <strong>nicht</strong> als Immobilienmakler
        im Sinne des § 34c GewO (Deutschland) bzw. § 117 GewO (Österreich) auf.
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>
        Eine Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG (Deutschland)
        bzw. UID-Nummer gemäß § 28 UStG (Österreich) liegt nicht vor. Die
        Gesellschaft unterliegt der US-amerikanischen Besteuerung.
      </p>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Die Kontaktaufnahme mit uns erfolgt über das Kontaktformular auf
        dieser Website.
      </p>

      <h2>
        Verbraucherstreitbeilegung / Universalschlichtungsstelle
      </h2>
      <p>
        Wir sind nicht bereit und nicht verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach
        den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht
        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
        überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
        Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
        Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
        unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
        der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
        entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser
        Website unterliegen dem Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors beziehungsweise Erstellers. Downloads und Kopien
        dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
        gestattet.
      </p>

      <h2>Bildnachweise</h2>
      <p>
        Immobilien-Darstellungen auf dieser Website sind teilweise redaktionelle
        Beispielbilder von Unsplash-Contributors und dienen der Illustration.
        Sie stellen keine Angebote konkreter Objekte dar.
      </p>
    </article>
  );
}
